module.exports = __webpack_public_path__ + "static/media/banner_rummy-half.d136152f.png";